import es6Promise from 'es6-promise';
import { createBrowserHistory } from 'history';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { prepareServices } from './contexts/servicesContext';
import Main from './main';
import { deferJQuery } from './utils/defer';

es6Promise.polyfill();
window.history.replaceState(null, '');

window.addEventListener('load', () => {
	deferJQuery((jQuery) => {
		if (jQuery.scrollDepth) {
			jQuery.scrollDepth({
				eventHandler: function (data) {
					window.OwnersManuals.tracking?.push(data);
				},
			});
		}
	});
});

const services = prepareServices(window.OwnersManuals.baseAppSettings, false, window.location);
const history = createBrowserHistory({ basename: services.config.historyBaseName });

ReactDOM.render(<Main history={history} services={services} />, document.getElementById('om-app'));
